/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { SetStore } from '@deqo/foundation';
import { EventSource, TopicData } from '@deqo/podopolis';
import { ServiceSymbol } from '../Container';
import { HangoutClient } from './HangoutClient';
import { HangoutEvents } from './HangoutEvents';
import { HangoutLocation } from './HangoutLocation';
import { HangoutPodSession } from './HangoutPodSession';
import { HangoutTopic } from './HangoutTopic';
import { HangoutUser } from './HangoutUser';

export interface HangoutClients extends SetStore<HangoutClient> {
    get(id: string): HangoutClient | null;
}

export interface HangoutLocations extends SetStore<HangoutLocation> {
    get(path: string): HangoutLocation | null;
}

export interface HangoutUsers extends SetStore<HangoutUser> {
    get(id: string): HangoutUser | null;
}

export type HangoutMessageReciever = (sender: HangoutClient, data?: any) => void;
export type HangoutTopicReciever = (data: TopicData, affectedKeys: string[]) => void;

export interface Hangout extends EventSource<HangoutEvents> {

    readonly self: HangoutClient;
    readonly clients: HangoutClients;
    readonly locations: HangoutLocations;
    readonly users: HangoutUsers;
    readonly ready: boolean;

    getPod(): HangoutPodSession | null;

    waitForReady(): Promise<void>;

    subscribeTo(topic: string): HangoutTopic;

    sendRelay(to: string | '*', type: string, data: any): void;

    updateMyLocation(): void;
}

export const Hangout = ServiceSymbol<Hangout>('Hangout');
